/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardDeptDialogController', BoardDeptDialogController);

    BoardDeptDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$http', 'Dept', 'entityProfile', 'entityProject', 'entityDinghyEvent', 'ProjectActive', 'DinghyEventActive', 'MemberManagement'];

    function BoardDeptDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, $http, Dept, entityProfile, entityProject, entityDinghyEvent, ProjectActive, DinghyEventActive, MemberManagement) {
        var vm = this;

        vm.dept = entity;
        vm.entityProfile = entityProfile;
        vm.profilePresent = entityProfile != null || vm.dept.profile != null;
        vm.relationClosed = false;
        vm.relationPresent = false;
        vm.hasCrews = false;
        if (vm.dept.id) {
            vm.dept.oldAmount = vm.dept.amount;
            vm.dept.oldApCount = vm.dept.apCount;
            vm.dept.availableActivityPoints += vm.dept.apCount;
            vm.projects = vm.dept.project ? [vm.dept.project] : [];
            vm.dinghyEvents = vm.dept.dinghyEvent ? [vm.dept.dinghyEvent] : [];
            vm.relationClosed = (vm.dept.project && vm.dept.project.closed) || (vm.dept.dinghyEvent && vm.dept.dinghyEvent.closed);
        } else {
            if (entityProject !== null) {
                vm.dept.project = entityProject;
                vm.projects = [vm.dept.project];
                vm.relationClosed = vm.dept.project.closed;
                vm.relationPresent = true;
                vm.hasCrews = vm.dept.project.type === 'event';
            }
            if (entityDinghyEvent !== null) {
                vm.dept.dinghyEvent = entityDinghyEvent;
                vm.dinghyEvents = [vm.dept.dinghyEvent];
                vm.relationClosed = vm.dept.dinghyEvent.closed;
                vm.relationPresent = true;
            }
            if (vm.relationClosed) {
                $timeout(function () {
                    clear();
                });
            }
            vm.dept.profile = vm.entityProfile;
            vm.dept.availableActivityPoints = 0;
        }
        vm.nickname = vm.dept.profile && vm.dept.profile.nickname ? " \"" + vm.dept.profile.nickname + "\"" : "";

        if (!vm.relationClosed && vm.entityProfile != null) {
            getProjects();
            getDinghyEvents();
        }
        if (entityProfile == null && vm.dept.profile != null) {
            MemberManagement.get({id: vm.dept.profile.id}, function (result) {
                vm.entityProfile = result;
                if (!vm.relationClosed) {
                    getProjects();
                    getDinghyEvents();
                }
            });
        }
        if (!vm.profilePresent) {
            vm.sortByCrew = false;
            vm.selectSingle = true;
            vm.profiles = [];
            if (entityProject !== null) {
                loadProfilesProject();
            } else {
                loadProfilesDinghyEvent();
            }
        }

        vm.clear = clear;
        vm.save = save;
        vm.onChange = onChange;
        vm.pointsPicked = pointsPicked;
        vm.getNewBookingSorting = getNewBookingSorting;

        onChange();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function getProjects() {
            ProjectActive.get({userId: vm.entityProfile.user.id}, function (data) {
                vm.projects = data;
            });
        }

        function getDinghyEvents() {
            DinghyEventActive.get({userId: vm.entityProfile.user.id}, function (data) {
                vm.dinghyEvents = data;
            });
        }

        function loadProfilesProject() {
            $http.get('api/board/bookings/dept', {
                params: {
                    projectID: entityProject.id
                }
            }).then(function (response) {
                vm.profiles = response.data;
                for (var i = 0; i < vm.profiles.length; i++) {
                    vm.profiles[i].nickname = vm.profiles[i].nickname ? " \"" + vm.profiles[i].nickname + "\"" : "";
                }
            });
        }

        function loadProfilesDinghyEvent() {
            $http.get('api/board/dinghy-bookings/dept', {
                params: {
                    eventId: entityDinghyEvent.id
                }
            }).then(function (response) {
                vm.profiles = response.data;
                for (var i = 0; i < vm.profiles.length; i++) {
                    vm.profiles[i].nickname = vm.profiles[i].nickname ? " \"" + vm.profiles[i].nickname + "\"" : "";
                }
            });
        }

        function pointsPicked() {
            vm.dept.apCount = Math.min($scope.maxPoints, vm.dept.apCount);
            onChange();
        }

        function calcMaxPoints() {
            var points = Math.floor(vm.dept.amount / vm.dept.pointValue);
            $scope.maxPoints = Math.min(vm.dept.availableActivityPoints, points);
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            pointsPicked();
            vm.isSaving = true;
            if (vm.dept.id) {
                Dept.update(vm.dept, onSaveSuccess, onSaveError);
            } else {
                if (vm.category != null && vm.category !== "") {
                    vm.dept.reference = vm.category;
                }
                if (!vm.profilePresent) {
                    if (vm.selectSingle) {
                        vm.profilesToCreate = [];
                    } else {
                        vm.profile = null;
                    }
                }
                Dept.save(vm.dept, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('askApp:deptUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function onChange() {
            calcMaxPoints();
            vm.dept.apValue = vm.dept.apCount * vm.dept.pointValue;
            $scope.toPay = vm.dept.amount - vm.dept.apValue;
            $scope.diff = vm.dept.payed - $scope.toPay;

            if (vm.dept.id && $.isNumeric(vm.dept.amount)) {
                $('#preCalc').show();
            } else {
                $('#preCalc').hide();
            }
        }

        function getNewBookingSorting() {
            return vm.sortByCrew ? "crewSorting" : "bookingId";
        }
    }
})();
